import React from 'react';
import { observer } from 'mobx-react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import MessageDialog from '10.quickConnect.app/components/shared/Dialogs/MessageDialog';
import useData from '10.quickConnect.app/components/shared/Dialogs/BackupDeclarationDialog/hooks';
import { choiceDialogName } from '10.quickConnect.app/components/shared/Dialogs/BackupDeclarationDialog/const';

// Reprise d'une saisie interrompue : fermer la popup la reprend
const BackupDeclarationDialog = () => {
  const { onResumeDeclaration, onDiscardDeclaration, unsavedEntryLabel, openModal, t } = useData();

  return (
    <MessageDialog
      name={choiceDialogName}
      open={openModal}
      onClose={onResumeDeclaration}
      title={t('qcapp_back_up_unsaved_entry_title').toString()}
      message={[t('qcapp_back_up_unsaved_entry_info').toString(), unsavedEntryLabel]}
      options={[
        {
          name: 'dialog-option-continue-dcl',
          label: t('qcapp_back_up_unsaved_entry_resume').toString(),
          icon: <EditIcon />,
          onClick: onResumeDeclaration,
        },
        {
          name: 'dialog-option-delete-dcl',
          label: t('qcapp_back_up_unsaved_entry_discard').toString(),
          icon: <DeleteIcon />,
          onClick: onDiscardDeclaration,
        },
      ]}
    />
  );
};

export default observer(BackupDeclarationDialog);
